import type { Provider } from "@src/interfaces/provider.interface";
import { useEffect, useRef } from "react";
import { ProviderTeamCard } from "../MeetTheTeam/ProviderTeamCard";

interface ViewportProviderTeamCardProps {
  provider: Provider;
  isPhotoLoading: boolean;
  onPhotoVisible: (provider: Provider) => void;
}

export const ViewportProviderTeamCard = ({
  provider,
  isPhotoLoading,
  onPhotoVisible,
}: ViewportProviderTeamCardProps) => {
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const card = cardRef.current;
    if (!card) {
      return;
    }

    if (!("IntersectionObserver" in window)) {
      onPhotoVisible(provider);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onPhotoVisible(provider);
          observer.disconnect();
        }
      },
      { rootMargin: "300px" },
    );
    observer.observe(card);

    return () => observer.disconnect();
  }, [onPhotoVisible, provider]);

  return (
    <div ref={cardRef} style={{ width: "100%", height: "100%", display: "flex" }}>
      <ProviderTeamCard
        provider={provider}
        isPhotoLoading={isPhotoLoading}
        fillAvailableHeight={true}
      />
    </div>
  );
};
